import { all, takeEvery, put, call } from 'redux-saga/effects';
import Api from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';
import { keyByProperty } from '../../../../helpers/core';
import logsActions from '../logs/actions';
import talentActions from '../actions';
import actions from './actions';
import { translationsRootKey } from '../../../../settings';
import { t } from '../../../../i18n';

const api = new Api('workers/:id/suspensions');
const updateApi = new Api('workers/:id/suspensions/:suspension_id');
const reinstateApi = new Api('workers/:id/suspensions/:suspension_id/reactivate');

function* loadFormData({ payload }) {
  try {
    const result = yield call(sendRequest, api.loadFormData, { id: payload.id }, notifications.REQUEST_ERROR);

    if (result) {
      const { data } = result.data.success;

      yield put(actions.loadFormDataSuccess({ data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* confirm({ payload }) {
  try {
    const { editForm, id } = payload;
    const propsArray = Object.values(editForm);
    const suspension = keyByProperty(propsArray, 'name', prop => prop.value);

    const result = yield call(
      sendRequest,
      api.multipleParamsCreateItem,
      { data: { ...suspension }, params: { id } },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      // Update Talent view page
      yield put(talentActions.loadData({ id }));
      // Update Logs section
      yield put(logsActions.loadData({ id }));
      yield put(actions.toggleSuspensionModal());
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t(`${translationsRootKey}.talent.talent_has_been_suspended_message`),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* update({ payload }) {
  try {
    const { editForm, id, suspension_id } = payload;
    const propsArray = Object.values(editForm);
    const suspension = keyByProperty(propsArray, 'name', prop => prop.value);

    const result = yield call(
      sendRequest,
      updateApi.multiparamsUpdateItem,
      { data: { ...suspension }, params: { id, suspension_id } },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      // Update Talent view page
      yield put(talentActions.loadData({ id }));
      // Update Logs section
      yield put(logsActions.loadData({ id }));
      yield put(actions.toggleSuspensionModal());
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t(`${translationsRootKey}.talent.talent_suspension_has_been_updated_message`),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* reinstate({ payload }) {
  try {
    const { id, suspension_id } = payload;

    const result = yield call(
      sendRequest,
      reinstateApi.multiparamsUpdateItem,
      { params: { id, suspension_id } },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      // Update Talent view page
      yield put(talentActions.loadData({ id }));
      // Update Logs section
      yield put(logsActions.loadData({ id }));
      yield put(actions.reinstateSuccess());
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t(`${translationsRootKey}.talent.status_changed_to_active_message`),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD_FORM_DATA, loadFormData),
    takeEvery(actions.CONFIRM, confirm),
    takeEvery(actions.UPDATE, update),
    takeEvery(actions.REINSTATE, reinstate),
  ]);
}
